module.exports = __webpack_public_path__ + "img/order_logo.8fe5e281.png";